import { render, staticRenderFns } from "./chuanggj.vue?vue&type=template&id=b3252626&scoped=true"
import script from "./chuanggj.vue?vue&type=script&lang=js"
export * from "./chuanggj.vue?vue&type=script&lang=js"
import style0 from "./chuanggj.vue?vue&type=style&index=0&id=b3252626&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3252626",
  null
  
)

export default component.exports